// third-party
import { Trans } from 'react-i18next';
// assets
import { IconBrandTwitch, IconDeviceAnalytics, IconReport, IconChartBar } from '@tabler/icons';

// constant
const icons = {
    IconBrandTwitch,
    IconChartBar,
    IconDeviceAnalytics,
    IconReport,
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== /

const emartmall = {
    id: 'emartmall',
    title: <Trans i18nKey="Emartmall" id="emartmall" />,
    type: 'group',
    children: [
        {
            id: 'orders',
            title: <Trans i18nKey="Orders" id="Orders" />,
            type: 'item',
            url: '/orders',
            icon: icons.IconBrandTwitch,
            breadcrumbs: false,
            children: [
                {
                    id: 'by-year',
                    title: (
                        <>
                            <Trans i18nKey="By Year" id="By Year" />
                        </>
                    ),
                    type: 'item',
                    url: '/report/by-year',
                    breadcrumbs: false,
                },
                {
                    id: 'by-month',
                    title: (
                        <>
                            <Trans i18nKey="By month" id="By month" />
                        </>
                    ),
                    type: 'item',
                    url: '/report/by-month',
                    breadcrumbs: false,
                },
                {
                    id: 'by-store',
                    title: (
                        <>
                            <Trans i18nKey="By stores" id="By stores" />
                        </>
                    ),
                    type: 'item',
                    url: '/report/by-stores',
                    breadcrumbs: false,
                },
            ]
        },
        {
            id: 'report',
            title: <Trans i18nKey="Report" id="Report" />,
            type: 'collapse',
            url: '/report/by-year',
            icon: icons.IconChartBar,
            breadcrumbs: false
        },
    ]
};

export default emartmall;
